import WarnerRobinsHeroSection from "./components/HeroSection";
import WarnerRobinsStickyNav from "./components/StickyNav";
import WarnerRobinsProcessingTimeSection from "./components/ProcessingTimeSection";
import WarnerRobinsServicesSection from "./components/ServicesSection";
import WarnerRobinsLocalAreaSection from "./components/LocalAreaSection";
import WarnerRobinsTestimonialsSection from "./components/TestimonialsSection";
import WarnerRobinsAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WarnerRobinsComparisonSection from "./components/ComparisonSection";
import WarnerRobinsMistakesSection from "./components/MistakesSection";
import WarnerRobinsHowItWorksSection from "./components/HowItWorksSection";
import WarnerRobinsFAQSection, { faqs } from "./components/FAQSection";
import WarnerRobinsHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WarnerRobinsFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WarnerRobinsPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Warner Robins"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/warner-robins"
        title="Emergency Passport Warner Robins, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Warner Robins, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Houston County, Robins AFB, Perry, Byron, and Fort Valley travelers. Get your emergency passport fast!"
        geoPlacename="Warner Robins, Georgia"
        geoPosition="32.6130;-83.6241"
        keywords="expedited passport, emergency passport, Warner Robins passport, same day passport Warner Robins, fast passport Houston County, Robins AFB passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <WarnerRobinsHeroSection />
      <WarnerRobinsStickyNav />
      <WarnerRobinsProcessingTimeSection />
      <WarnerRobinsLocalAreaSection />
      <WarnerRobinsServicesSection />
      <WarnerRobinsTestimonialsSection />
      <WarnerRobinsAcceptanceFacilitiesSection />
      <WarnerRobinsComparisonSection />
      <WarnerRobinsMistakesSection />
      <WarnerRobinsHowItWorksSection />
      <WarnerRobinsFAQSection />
      <WarnerRobinsHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/warner-robins" state="GA" />
      <WarnerRobinsFinalCTA />
    </div>
  );
}